import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Subject } from 'rxjs';
import { environment } from 'src/environments/environment';

@Injectable({
  providedIn: 'root'
})
export class SliderService {

  selectedCategory: any = null;
  public selectedCategoryChange: Subject<any> = new Subject<any>();
  slidersUrl = environment.API_URL + "/Slider";
  sliderBenefit = environment.API_URL + "/slider/slider-dynamic";

  constructor(private http: HttpClient) { }

  getAll(): any {
    return this.http.get(this.slidersUrl);
  }

  getCurrent(): any {
    return this.http.get(this.slidersUrl + '?current=true');
  }

  getSliderBenefits(): any {
    const today = new Date().toISOString().substring(0, 19);
    const urlWithDate = `${this.sliderBenefit}?date=${today}`;
    return this.http.get(urlWithDate);
  }
}
